import React from 'react';
import UserInfoModal from '../../../../screens/UserInfo/UserInfoModal';

const UserInfo2 = (props) => {
    return <UserInfoModal {...props} />;
}

export default UserInfo2;
